import { format } from 'date-fns-tz';

export function getTimezoneOffsetInValidPattern(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!timeZone) {
    return '';
  }

  return format(new Date(), 'xxx', { timeZone });
}
